import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';
import { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { ArrowRightShort } from '../assets/icons';
import { billingXL, generalXL, medicalXL, systemXL } from '../assets/images';
import { TrustBoxWide } from '../components/trustBox';

function Faqs() {
  const [activeTab, setActiveTab] = useState(navSections[0].path);
  const handleClick = (test) => {
    setActiveTab(test);
  };
  return (
    <main>
      <Script
        type='text/javascript'
        src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        strategy='lazyOnload'
      />
      <Head>
        <title>Frequently Asked Questions - 24hrdoc</title>
        <meta
          name='description'
          content="Find answers to common questions about 24hrdoc's telehealth services, online doctor visits, prescriptions, and virtual healthcare solutions."
        />
        <meta
          property='og:image'
          content={
            'https://www.24hrdoc.com/_next/image?url=%2Fassets%2Fimages%2Fnew%2FheroReview.png&w=640&q=75'
          }
        />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={addFaqsJsonLD()}
          key='faqs-jsonld'
        />
        <link rel='canonical' href='https://www.24hrdoc.com/faqs' />
      </Head>
      <div className='heroWrapper'>
        <div className='heroContent'>
          <h1 className='heroHeading'>
            Frequently asked <span className='gradientTitle'>questions</span>
          </h1>
          <p className='heroPara'>
            {/* <span>
              Have questions? Here you&apos;ll find the answers most asked by
              our users, along with access to important information and support.
            </span> */}
            Have questions? Here you&apos;ll find the answers most asked by our
            users, along with access to
            <br className='tw-hidden lg:tw-block' /> important information and
            support.
          </p>
          {/* <div className='searchBarDiv'>
            <input
              className='searchBar'
              type='text'
              placeholder='Search question'
            />
            <div className='searchIconBg'>
              <SearchIcon />
            </div>
          </div> */}
        </div>
      </div>
      {/* The Tabs */}
      <div className='tabsWrapper'>
        <div className='tabs'>
          <div className='navTabs'>
            {navSections.map((item) => (
              <a
                href={item.path}
                key={item.name}
                onClick={() => handleClick(item.path)}
                className={`theLink ${activeTab === item.path ? 'active' : ''}`}
              >
                {item.name}
              </a>
            ))}
          </div>
        </div>

        <div className='theFAQS'>
          <div className='faqOuterDiv' id='general'>
            {/* The Image */}

            <div className='imgDiv'>
              {/* <Image src={general} width={630} height={632} /> */}
              <Image
                src={generalXL}
                layout='fill'
                objectFit='cover'
                quality={80}
                style={{
                  borderRadius: '1.25rem',
                }}
                alt='general'
              />
            </div>
            <div className='faqDiv general'>
              <h4 className='faqHeading'>General</h4>
              <Accordion flush>
                {generalFAQS.map((item) => (
                  <Accordion.Item key={item.id} eventKey={item.id}>
                    <Accordion.Header>{item.question}</Accordion.Header>

                    <Accordion.Body>{item.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>

          {/* System Usage */}

          <div className='faqOuterDiv' id='system'>
            <div className='faqDiv system'>
              <h4 className='faqHeading'>System Usage</h4>
              <Accordion flush>
                {SystemFAQS.map((item) => (
                  <Accordion.Item key={item.id} eventKey={item.id}>
                    <Accordion.Header>{item.question}</Accordion.Header>

                    <Accordion.Body>{item.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
            {/* The Image */}
            <div className='imgDiv imgRight'>
              {/* <Image src={general} width={630} height={632} /> */}
              <Image
                src={systemXL}
                layout='fill'
                objectFit='cover'
                quality={80}
                style={{ borderRadius: '1.25rem' }}
                alt='system'
              />
            </div>
          </div>

          {/* Medical Services */}
          <div className='faqOuterDiv' id='medical'>
            {/* The Image */}

            <div className='imgDiv'>
              {/* <Image src={general} width={630} height={632} /> */}
              <Image
                src={medicalXL}
                layout='fill'
                objectFit='cover'
                quality={80}
                style={{ borderRadius: '1.25rem' }}
                alt='medical'
              />
            </div>
            <div className='faqDiv general'>
              <h4 className='faqHeading'>Medical Services</h4>
              <Accordion flush>
                {MedicalFAQS.map((item) => (
                  <Accordion.Item key={item.id} eventKey={item.id}>
                    <Accordion.Header>{item.question}</Accordion.Header>

                    <Accordion.Body>{item.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>

          {/* Billing & Payments */}
          <div className='faqOuterDiv' id='billing'>
            <div className='faqDiv system'>
              <h4 className='faqHeading'>Billing & Payments</h4>
              <Accordion flush>
                {BillingFAQS.map((item) => (
                  <Accordion.Item key={item.id} eventKey={item.id}>
                    <Accordion.Header>{item.question}</Accordion.Header>

                    <Accordion.Body>{item.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
            {/* The Image */}
            <div className='imgDiv imgRight'>
              {/* <Image src={general} width={630} height={632} /> */}
              <Image
                src={billingXL}
                layout='fill'
                objectFit='cover'
                quality={80}
                style={{ borderRadius: '1.25rem' }}
                alt='billing'
              />
            </div>
          </div>

          {/* More Help */}
          <div className='helpDiv'>
            <div className='helpContent'>
              <h6 className='helpHeading'>Need More Help?</h6>
              <p className='helpPara'>
                If your question isn&apos;t covered in our FAQs, contact us
                anytime. We&apos;re just a message away!
              </p>
            </div>
            <div className='contact'>
              <Link href='/services'>
                <p className='contactBtn'>
                  Start consultation <ArrowRightShort />
                </p>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className='faqTrustBox'>
        <TrustBoxWide />
      </div>

      {/* The Bottom Image */}
      {/* <BottomImage path={'/services'} /> */}
    </main>
  );
}
function addFaqsJsonLD() {
  return {
    __html: `{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How does the 24hrdoc work?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It is a simple and fast process. You select the medical condition available on the website, answer questions about your health, and submit the information for provider review. In some cases, additional details may be requested via phone or text. Prescriptions are sent directly to your pharmacy."
      }
    },
    {
      "@type": "Question",
      "name": "What are Telehealth Services at 24hrdoc?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Telehealth uses digital communication technologies to provide remote healthcare services. 24hrdoc offers 24/7 access to medical professionals for consultation, diagnosis, treatment, and prescriptions online."
      }
    },
    {
      "@type": "Question",
      "name": "How do I use the 24hrdoc online service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Create an account to access services. Once registered, you can use available resources, ask questions, or chat with a doctor via live support."
      }
    },
    {
      "@type": "Question",
      "name": "Is there a fee for using the 24hrdoc online service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, fees vary by condition and are paid before the visit. Costs depend on the treatment selected. Contact support for more details."
      }
    },
    {
      "@type": "Question",
      "name": "What if my pharmacy does not have my medication?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Contact support immediately. The prescription can be forwarded to another pharmacy to ensure you receive your medication promptly."
      }
    },
    {
      "@type": "Question",
      "name": "Is my personal information secure on 24hrdoc?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, your information is protected using the latest encryption technology and is not shared with third parties without your consent."
      }
    },
    {
      "@type": "Question",
      "name": "How do I sign up for 24hrdoc?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Click 'Sign Up' on the website or app, fill in your details, verify your email, and start using the service."
      }
    },
    {
      "@type": "Question",
      "name": "Is there a 24hrdoc mobile app?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, 24hrdoc is available on iOS and Android via the App Store and Google Play."
      }
    },
    {
      "@type": "Question",
      "name": "How can I book an appointment?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Log in, select a provider, choose a time slot, and confirm your appointment through the platform."
      }
    },
    {
      "@type": "Question",
      "name": "What if my video consultation doesn't work?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Ensure permissions are enabled, your internet connection is stable, and restart your device if needed. Support is available for assistance."
      }
    },
    {
      "@type": "Question",
      "name": "Can I view my consultation history?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all past appointments, notes, and prescriptions are stored in the 'My Consultations' section of your account."
      }
    },
    {
      "@type": "Question",
      "name": "Is support available if I have technical issues?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, customer support is available 24/7 via chat, phone, and email."
      }
    },
    {
      "@type": "Question",
      "name": "What types of conditions can 24hrdoc treat?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "24hrdoc treats non-emergency conditions such as cold and flu, allergies, skin rashes, infections, and mental health concerns."
      }
    },
    {
      "@type": "Question",
      "name": "Does 24hrdoc offer access to specialists?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, appointments with specialists like dermatologists and mental health professionals are available."
      }
    },
    {
      "@type": "Question",
      "name": "Are mental health services available through 24hrdoc?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, licensed therapists and counselors are available for consultations and ongoing therapy."
      }
    },
    {
      "@type": "Question",
      "name": "Can children use 24hrdoc?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Children can only be seen when accompanied by a parent or legal guardian during the appointment."
      }
    },
    {
      "@type": "Question",
      "name": "How does 24hrdoc handle prescriptions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prescriptions are electronically sent to your preferred pharmacy after provider approval."
      }
    },
    {
      "@type": "Question",
      "name": "What if I need in-person medical care?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "If needed, providers will recommend in-person care and refer you to appropriate local services."
      }
    },
    {
      "@type": "Question",
      "name": "How much does a consultation on 24hrdoc cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Costs typically range from $40 to $90 depending on the service and provider. Exact pricing is shown before booking."
      }
    },
    {
      "@type": "Question",
      "name": "Does 24hrdoc accept insurance?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No, insurance is not accepted for consultations. However, insurance may cover pharmacy medications, labs, or imaging services."
      }
    },
    {
      "@type": "Question",
      "name": "Which payment methods does 24hrdoc support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Accepted methods include credit/debit cards, HSA/FSA cards, and digital wallets such as Apple Pay and Google Pay."
      }
    },
    {
      "@type": "Question",
      "name": "Will I receive a receipt after payment?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, a detailed receipt is sent via email and can also be downloaded from your account dashboard."
      }
    },
    {
      "@type": "Question",
      "name": "Is there financial assistance through 24hrdoc?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, reduced fees and flexible payment options are available for qualified users. Contact support for details."
      }
    },
    {
      "@type": "Question",
      "name": "What is the refund policy of 24hrdoc?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Refunds are reviewed case-by-case. Contact support within 7 days if you experience an issue."
      }
    }
  ]
}`,
  };
}

export default Faqs;
const navSections = [
  { id: 1, name: 'General', path: '#general' },
  { id: 2, name: 'System Usage', path: '#system' },
  { id: 3, name: 'Medical Services', path: '#medical' },
  { id: 4, name: 'Billing & Payments', path: '#billing' },
];
const generalFAQS = [
  {
    id: 1,
    question: `How does the 24hrDoc work?`,
    answer: `It is a simple and fast process. You just select the medical condition you need to consult and that is available on our website, then, answer the questions about your health, and send the information to be reviewed by our providers. In some cases, it will be necessary to obtain more details about your medical condition and we will request information through a phone call or text message. Finally, we will send the prescription directly to the pharmacy for your convenience.`,
  },
  {
    id: 2,
    question: ` What are Telehealth Services at 24hrDoc?`,
    answer: `Telehealth is the use of digital information and communication technologies to access health care services remotely and manage your health. 24hrDoc services provide around-the-clock access to medical dr online and other medical professionals for consultation, diagnosis, treatment, and getting a doctor&apos;s prescription online.`,
  },
  {
    id: 3,
    question: `How do I use the 24hrDoc online service?`,
    answer: `To use the 24hrDoc online service, you must create an account. Once you have an account, you can access all of the resources available through your account. You can also ask questions using the Ask A Question function or chat with a doctor directly using our live support system.`,
  },
  {
    id: 4,
    question: `Is there a fee for using the 24hrdoc online service?`,
    answer: `We do have a fee and it's on each of our conditions and it&apos;s paid before any visit. There is some nominal cost for each treatment that you will opt for. You can find more information about costs and fees by contacting us.`,
  },
  {
    id: 5,
    question: `What if my pharmacy does not have my medication?`,
    answer: `If this happens, you should contact us immediately. We will be happy to help you solve this problem by forwarding the prescription to other pharmacies so that you can receive your medication as soon as possible.`,
  },
  {
    id: 6,
    question: `Is my personal information secure on 24hrdoc?`,
    answer: `Yes,Your Personal information is secure on 24hrDoc. We use the latest encryption technology to protect your personal information. We do not share your information with any third party without your consent.`,
  },
];
const SystemFAQS = [
  {
    id: 1,

    question: 'How do I sign up for 24hr Doc?',

    answer:
      "Simply click 'Sign Up' on the website or app, fill in your details, verify your email, and you're ready to start using 24hr Doc.",
  },

  {
    id: 2,

    question: 'Is there a 24hr Doc mobile app?',

    answer:
      'Yes, 24hr Doc is available on both iOS and Android. Download it from the App Store or Google Play for the best experience.',
  },

  {
    id: 3,

    question: 'How can I book an appointment?',

    answer:
      'After logging in, choose a provider, pick a time slot, and confirm your appointment through the 24hr Doc platform.',
  },

  {
    id: 4,

    question: "What if my video consultation doesn't work?",

    answer:
      'Ensure your device permissions are enabled, internet is stable, and try restarting your device. Our support team is also available to help.',
  },

  {
    id: 5,

    question: 'Can I view my consultation history?',

    answer:
      "Yes, all your past appointments, notes, and prescriptions are stored in the 'My Consultations' section of your 24hr Doc account.",
  },

  {
    id: 6,

    question: 'Is support available if I have technical issues?',

    answer:
      'Yes, our customer support team is available 24/7 via chat, phone, and email to assist with any issues on 24hr Doc.',
  },
];

const MedicalFAQS = [
  {
    id: 1,

    question: 'What types of conditions can 24hr Doc treat?',

    answer:
      '24hr Doc treats non-emergency conditions like cold & flu, allergies, skin rashes, infections, and mental health concerns.',
  },

  {
    id: 2,

    question: 'Does 24hr Doc offer access to specialists?',

    answer:
      'Yes, you can book appointments with various specialists including dermatologists, mental health experts, and more through 24hr Doc.',
  },

  {
    id: 3,

    question: 'Are mental health services available through 24hr Doc?',

    answer:
      'Yes, licensed therapists and counselors are available for mental health consultations and ongoing therapy sessions.',
  },

  {
    id: 4,

    question: 'Can children use 24hr Doc?',

    answer:
      'No, children can not be seen via 24hr Doc with a parent or legal guardian present during the appointment.',
  },

  {
    id: 5,

    question: 'How does 24hr Doc handle prescriptions?',

    answer:
      'Prescriptions are electronically sent to your preferred pharmacy after your provider determines they are necessary.',
  },

  {
    id: 6,

    question: 'What if I need in-person medical care?',

    answer:
      'If your case requires physical evaluation, 24hr Doc providers will advise you and refer you to appropriate local care.',
  },
];

const BillingFAQS = [
  {
    id: 1,

    question: 'How much does a consultation on 24hr Doc cost?',

    answer:
      'Costs vary by service and provider, typically ranging from $40 to $90. The exact fee is shown before confirming your appointment.',
  },

  {
    id: 2,

    question: 'Does 24hr Doc accept insurance?',

    answer:
      'No, insurance benefits do not apply to cover our services, and we do not file insurance claims. Your insurance may be used to pay for pharmacy medications, lab tests, x-ray imaging services and other tests.',
  },

  {
    id: 3,

    question: 'Which payment methods does 24hr Doc support?',

    answer:
      '24hr Doc accepts credit/debit cards, HSA/FSA cards, and digital wallets like Apple Pay and Google Pay.',
  },

  {
    id: 4,

    question: 'Will I receive a receipt after payment?',

    answer:
      'Yes, a detailed receipt will be sent to your registered email and is also available for download from your account dashboard.',
  },

  {
    id: 5,

    question: 'Is there financial assistance through 24hr Doc?',

    answer:
      'Yes, we offer reduced fees and flexible options for those who qualify. Contact our support team to explore available programs.',
  },

  {
    id: 6,

    question: 'What is the refund policy of 24hr Doc?',

    answer:
      'Refunds are evaluated on a case-by-case basis. Please contact support within 7 days if you had an issue with your consultation.',
  },
];
